import React, { FC } from "react";
import { defineMessages, useIntl } from "react-intl";

import { useCbtSaveGuestCheckbox } from "shared/hooks/cbtSaveGuestCheckbox";
import { formattedMessageParams } from "shared/messages";

import CustomCheckbox from "@components/Forms/Inputs/CustomCheckbox";

const { cbtSaveGuest } = defineMessages({
  cbtSaveGuest: formattedMessageParams("CBTSaveGuestCheckbox.saveCBTGuest"),
});

const CbtSaveGuestCheckbox: FC<{
  indexPassenger: number;
}> = ({ indexPassenger }) => {
  const intl = useIntl();

  const { isChecked, handleCheck } = useCbtSaveGuestCheckbox({
    indexPassenger,
  });

  return (
    <CustomCheckbox
      defaultMessage={intl.formatMessage(cbtSaveGuest)}
      input={{ checked: isChecked, onChange: handleCheck }}
    />
  );
};

export default CbtSaveGuestCheckbox;
